import { render, staticRenderFns } from "./HasWonTheBid.vue?vue&type=template&id=2af4f988&scoped=true"
import script from "./HasWonTheBid.vue?vue&type=script&lang=js"
export * from "./HasWonTheBid.vue?vue&type=script&lang=js"
import style0 from "./HasWonTheBid.vue?vue&type=style&index=0&id=2af4f988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4f988",
  null
  
)

export default component.exports